import { render, staticRenderFns } from "./DigilockerSrc.vue?vue&type=template&id=451ca1b0"
import script from "./DigilockerSrc.vue?vue&type=script&lang=js"
export * from "./DigilockerSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports